export const SOCKET_START_CHANNEL = 'SOCKET_START_CHANNEL';
export const SOCKET_STOP_CHANNEL = 'SOCKET_STOP_CHANNEL';
export const SOCKET_CHANNEL_ON = 'SOCKET_CHANNEL_ON';
export const SOCKET_CHANNEL_OFF = 'SOCKET_CHANNEL_OFF';
export const SOCKET_SERVER_ON = 'SOCKET_SERVER_ON';
export const SOCKET_SERVER_OFF = 'SOCKET_SERVER_OFF';
